// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7a784c60","329":"dfa2dafd","373":"cfa85e61","667":"01956e77","757":"d6414aad","977":"d5ae39d7"}[chunkId] + ".chunk.js";
};